<div
  cdkDrag
  class="floating-progress-dialog"
  [cdkDragDisabled]="isMinimized"
  [class.floating-progress-dialog--minimized]="isMinimized"
  role="region"
  [attr.aria-label]="progressTitle"
>
  <ng-container *ngIf="!isMinimized; else minimizedView">
    <div
      cdkDragHandle
      class="floating-progress-dialog__header"
    >
      <span>{{ progressTitle }}</span>
      <div class="floating-progress-dialog__actions">
        <span
          class="floating-progress-dialog__drag-handle"
          aria-hidden="true"
        ></span>
        <button
          type="button"
          class="floating-progress-dialog__action floating-progress-dialog__close"
          aria-label="Minimize progress dialog"
          title="Minimize"
          (pointerdown)="$event.stopPropagation()"
          (click)="minimize()"
        >
          &times;
        </button>
      </div>
    </div>
    <div class="floating-progress-dialog__content" aria-live="polite">
      <div class="floating-progress-dialog__value">
        <span>{{ progressLabel }}</span>
        <span>{{ progressText || progressValue + "%" }}</span>
      </div>
      <p-progressBar
        [value]="progressValue"
        [showValue]="false"
        styleClass="floating-progress-bar"
      ></p-progressBar>
      <div
        *ngIf="progressSubtext"
        class="floating-progress-dialog__subtext"
      >
        {{ progressSubtext }}
      </div>
    </div>
  </ng-container>

  <ng-template #minimizedView>
    <button
      type="button"
      class="floating-progress-dialog__restore"
      aria-label="Maximize progress dialog"
      [title]="'Show progress (' + progressValue + '%)'"
      (click)="maximize()"
    >
      <img
        src="/assets/images/icon-info-grey.svg"
        alt=""
        aria-hidden="true"
      />
    </button>
  </ng-template>
</div>